// extracted by mini-css-extract-plugin
export default {"contract":"ContractItem_contract__3Kwyv","main":"ContractItem_main__CwDJR","link":"ContractItem_link__y5daX"};